import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const RemovePluginCollaboratorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePluginCollaborator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePluginCollaborator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"RemovePluginCollaborator","document":RemovePluginCollaboratorDocument}} as const;
export type RemovePluginCollaboratorMutationVariables = Types.Exact<{
  idMember: Types.Scalars['ID']['input'];
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type RemovePluginCollaboratorMutation = (
  { __typename: 'Mutation' }
  & { removePluginCollaborator?: Types.Maybe<(
    { __typename: 'Plugin_Collaborators_UpdateResponse' }
    & Pick<Types.Plugin_Collaborators_UpdateResponse, 'success'>
  )> }
);

export type RemovePluginCollaboratorMutationFn = Apollo.MutationFunction<
  RemovePluginCollaboratorMutation,
  RemovePluginCollaboratorMutationVariables
>;

/**
 * __useRemovePluginCollaboratorMutation__
 *
 * To run a mutation, you first call `useRemovePluginCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePluginCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePluginCollaboratorMutation, { data, loading, error }] = useRemovePluginCollaboratorMutation({
 *   variables: {
 *      idMember: // value for 'idMember'
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function useRemovePluginCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePluginCollaboratorMutation,
    RemovePluginCollaboratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePluginCollaboratorMutation,
    RemovePluginCollaboratorMutationVariables
  >(RemovePluginCollaboratorDocument, options);
}
export type RemovePluginCollaboratorMutationHookResult = ReturnType<
  typeof useRemovePluginCollaboratorMutation
>;
export type RemovePluginCollaboratorMutationResult =
  Apollo.MutationResult<RemovePluginCollaboratorMutation>;
export type RemovePluginCollaboratorMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePluginCollaboratorMutation,
    RemovePluginCollaboratorMutationVariables
  >;
